import React, { useContext, useEffect } from 'react'
import { BrowserRouter, Redirect, Route, RouteComponentProps, Switch, useHistory, useLocation } from 'react-router-dom'
import { Signin } from '@/components/pages/signin'
import { Dashboard } from '@/components/pages/dashboard'
import { ReservationDetail } from '@/components/pages/accommodation-management/reservation/detail'
import { AccommodationManagement } from '@/components/pages/accommodation-management/list'
import { CustomerList } from '@/components/pages/customer-manager/list'
import { CheckinDetail } from '@/components/pages/accommodation-management/checkin/detail'
import { StayDetail } from '@/components/pages/accommodation-management/stay/detail'
import { CheckoutDetail } from '../pages/accommodation-management/checkout/detail'
import { EntireSearch } from '../pages/accommodation-management/entire-search'
import { UploadHistory } from '@/components/pages/accommodation-management/upload-history/upload-history'
import { DownloadHistory } from '@/components/pages/accommodation-management/download-history/download-history'
import { ReceiptHistory } from '@/components/pages/sales-manager/receipt-history'
import { CustomerDetail } from '@/components/pages/customer-manager/detail'
import { RoomManagerDaily } from '@/components/pages/room-manager/daily'
import { RoomManagerIndicator } from '@/components/pages/room-manager/indicator'
import { RequestManager } from '@/components/pages/request-manager'
import { CheckinPayment } from '@/components/pages/self-checkin/payment'
import { SalesManagerDetailByDaily } from '@/components/pages/sales-manager/sales/detail-by-daily'
import { SalesManagerDetailList } from '@/components/pages/sales-manager/sales/detail-list'
import { SalesManagerBusinessForms } from '@/components/pages/sales-manager/business-forms'
import { OperationLog } from '@/components/pages/operation-log'
import { OperationLogLegacyPage } from '@/components/pages/operation-log/operation-log-legacy-page'
import { SettingAccount } from '@/components/pages/setting/account'
import { SettingAccountEdit } from '@/components/pages/setting/account/edit'
import { SettingAccountReceiptEdit } from '@/components/pages/setting/account/receipt-edit'
import { SettingAccountCompanyInfoEdit } from '@/components/pages/setting/account/company-info-edit'

import { SettingGuestRoomNumber } from '@/components/pages/setting/guest-room/room/guest-room-number'
import { SettingGuestRoomType } from '@/components/pages/setting/guest-room/room/guest-room-type'
import { SettingGuestRoomFloor } from '../pages/setting/guest-room/room/guest-room-floor'
import { SettingGuestRoomAutoAssign } from '../pages/setting/guest-room/room/guest-room-auto-assign'
import { SettingGuestRoomKey } from '@/components/pages/setting/guest-room/key-number/index'
import { SettingRoomRateRank } from '@/components/pages/setting/room-rate/rank/price-rank'
import { SettingRoomRateBase } from '@/components/pages/setting/room-rate/base-rate/base-rate'
import { SettingRoomRateCalendar } from '@/components/pages/setting/room-rate/calendar/rate-calendar'

import { SettingSalesManagerSales } from '@/components/pages/setting/sales-manager/sales'
import { SettingSalesManagerPayment } from '@/components/pages/setting/sales-manager/payment/list'
import { SettingSalesManagerRegister } from '@/components/pages/setting/sales-manager/register/list'
import { SettingSalesManagerDiscount } from '@/components/pages/setting/sales-manager/discount/list'
import { SettingSalesManagerSubjectSet } from '@/components/pages/setting/sales-manager/subject-set'
import { SettingSalesManagerPaymentEdit } from '@/components/pages/setting/sales-manager/payment/edit'
import { SettingSalesManagerRegisterEdit } from '@/components/pages/setting/sales-manager/register/register-edit'
import { SettingSalesManagerDiscountEdit } from '@/components/pages/setting/sales-manager/discount/edit'
import { SettingCustomCheckin } from '@/components/pages/setting/custom-checkin'
import { SettingCustomCheckinEdit } from '@/components/pages/setting/custom-checkin/edit'
import { SettingSelfCheckin } from '@/components/pages/setting/self-checkin'
import { SettingPrinterSelfCheckin } from '@/components/pages/setting/printer/self-checkin'
import { SettingPrinterRequest } from '@/components/pages/setting/printer/request'
import { SettingReservationMarketSegment } from '@/components/pages/setting/reservation/market-segment'
import { SettingReservationMarketSegmentEdit } from '@/components/pages/setting/reservation/market-segment/edit'
import { SettingReservationChannelCode } from '@/components/pages/setting/reservation/channel-code'
import { SettingReservationChannelCodeEdit } from '@/components/pages/setting/reservation/channel-code/edit'
import { SettingPayment } from '@/components/pages/setting/setting-payment'
import { SettingStaff } from '@/components/pages/setting/setting-staff'
import { SettingNotification } from '@/components/pages/setting/notification'
import { SettingCleaningManager } from '@/components/pages/setting/cleaning-manager'
import { CheckList } from '../pages/setting/cleaning-manager/check-list'
import { SettingSurvey } from '@/components/pages/setting/survey'
import { SurveyEdit } from '@/components/pages/setting/survey/edit'
import { SurveyGoogleMap } from '@/components/pages/setting/survey/google-map'

import { FrontTabletHome } from '@/components/pages/self-checkin/front-tablet-home'
import { TabletRegisterPage } from '@/components/pages/tablet-register'
import { SelfCheckinComplete } from '@/components/pages/self-checkin/complete'

import { QrScan } from '@/components/pages/qr-checkin/scan'
import { QrCamera } from '@/components/pages/qr-checkin/camera'
import { QrComplete } from '@/components/pages/qr-checkin/complete'
import { SettingSalesManagerAccountsReceivable } from '../pages/setting/sales-manager/accounts-receivable/list'
import { SettingSalesManagerAccountsReceivableEdit } from '../pages/setting/sales-manager/accounts-receivable/edit'
import MobileMenu from '@/components/pages/mobile-menu'
import { CleaningManager as CleaningManagerForCleaner } from '@/components/pages/cleaning-manager/cleaner'
import { CleaningManager } from '@/components/pages/cleaning-manager'
import { CouponsManager } from '@/components/pages/coupons-manager'
import { ReportsManager } from '@/components/pages/reports-manager'
import { SearchReservation } from '../pages/self-checkin/search-reservation'
import { SelectReservation } from '../pages/self-checkin/select-reservation'
import { AccommodationInfo } from '../pages/self-checkin/accommodation-info'
import { CheckinCustomize } from '../pages/self-checkin/checkin-customize'
import { UploadLicense as SelfCheckinUploadLicense } from '../pages/self-checkin/identity-verify/upload-license'
import { UploadPassport as SelfCheckinUploadPassport } from '../pages/self-checkin/identity-verify/upload-passport'
import { Index as SelfCheckinConfirm } from '../pages/self-checkin/confirm'
import { InfoEdit as SelfCheckinInfoEdit } from '../pages/self-checkin/info-edit'
import { AdvanceMoney } from '../pages/sales-manager/advance-money'

import { AuthContext } from '@/contexts/auth'
import { AccountContext } from '@/contexts/account'
import { hasCleanerRole, hasRestaurantOnlyRole, hasStaffRole, usesHotelPmsStaffPermissions } from '@/libs/account'
import { findFirstAllowedStaffPath, getScreenKeyByPathname, isScreenDenied } from '@/libs/hotel-pms-permission'
import Media from 'react-media'
import * as NewCheckinSetting from '../pages/setting/checkin'
import { SettingGuestAppAsset } from '../pages/setting/guest-app/asset'
import { SettingGuestAppAssetDetail } from '../pages/setting/guest-app/asset-detail'
import { SettingGuestAppDesign } from '../pages/setting/guest-app/design'
import { SettingMailDelivery } from '../pages/setting/mail-delivery'
import { SettingReplyTo } from '../pages/setting/mail-delivery/reply-to'
import { MailDeliveryContentNew } from '../pages/setting/mail-delivery/content/mail/new'
import { MailDeliveryContentEdit } from '../pages/setting/mail-delivery/content/mail/edit'
import { MailDeliveryHistoryList } from '../pages/mail-delivery-history'
import { SettingSalesManagerDepartment } from '../pages/setting/sales-manager/department'
import { SettingSalesManagerSubSubject } from '../pages/setting/sales-manager/sub-subject'
import { SpaceManager } from '../pages/space-manager'
import { SmartKeySpace } from '../pages/setting/smart-key/space'
import { InvoiceManagerList } from '../pages/invoice-manager/list'
import { SalesManagerDashboard } from '../pages/sales-manager/sales/dashboard'
import { SalesManagerAccounting } from '../pages/sales-manager/accounting'
import { CustomerManager } from '../pages/setting/customer-manager'
import { CustomerDownloadHistory } from '../pages/customer-manager/download-history'
import { Schedule as CleaningManagerSchedule } from '../pages/cleaning-manager/schedule'
import { CleaningManagerDetail } from '../pages/cleaning-manager/cleaner/detail'
import { CleaningManagerScheduleForCleaner } from '../pages/cleaning-manager/cleaner/schedule'
import { SettingSalesManagerTax } from '../pages/setting/sales-manager/tax'
import { SelfCheckinIssueRoomKey } from '../pages/self-checkin/issue-room-key'
import { SettingReservationPlan } from '../pages/setting/reservation/plan'
import { SettingReservationTaskManagement } from '@/components/pages/setting/reservation/task-management'
import { SelfCheckinPaymentTerminalWithCard } from '../pages/self-checkin/payment/terminal-with-card'
import { SelfCheckinPaymentTerminalWithQr } from '../pages/self-checkin/payment/terminal-with-qr'
import { SmartCheckinQrReader } from '../pages/self-checkin/smart-checkin-qr-reader'
import { CustomExport } from '../pages/accommodation-management/custom-export'
import { SMSDeliveryContentEdit } from '../pages/setting/mail-delivery/content/sms/edit'
import { SMSDeliveryContentNew } from '../pages/setting/mail-delivery/content/sms/new'
import { AccountsReceivableManagerReceiptHistory } from '../pages/accounts-receivable-manager/receipt-history'
import { AccountsReceivableManagerBalance } from '../pages/accounts-receivable-manager/balance'
import { AccountsReceivableManagerList } from '../pages/accounts-receivable-manager/list'
import { SalesManagerDetailByMonthly } from '../pages/sales-manager/sales/detail-by-monthly'
import * as Checkout from '@/components/pages/self-checkout'
import { SurveySummary } from '../pages/survey/summary'
import { SurveyAnswers } from '../pages/survey/answers'
import { AdditionalGuestInfo } from '../pages/self-checkin/additional-guest-info'
import { AdditionalGuestInfoEdit } from '../pages/self-checkin/additional-guest-info-edit'
import { PermissionDenied } from '../pages/permission-denied'
import { AccountsReceivableDisplay } from '../pages/setting/sales-manager/accounts-receivable-display'
import { SettingRestaurantDisplaySubject } from '../pages/setting/restaurant/display-subject'
import { SettingRestaurantHighlight } from '../pages/setting/restaurant/highlight'
import { RestaurantManager } from '../pages/restaurant-manager'
import { ReservationSuggest } from '../pages/reservation/suggest'
import { VerifyOtp } from '../pages/signin/verify-otp'
import { MfaAnnounce } from '../pages/signin/mfa-announce'
import { reservationDetailRouteKey } from '@/utils/reservations'

// 詳細画面はマウント時にだけ予約を取得するため、別の予約へ遷移したときに作り直す
const ReservationDetailRoute = ({
  component: Component,
  ...routeProps
}: RouteComponentProps & { component: React.ComponentType<RouteComponentProps> }) => (
  <Component key={reservationDetailRouteKey(routeProps.location.pathname, routeProps.location.search)} {...routeProps} />
)

/** BrowserRouter 配下で pathname 変更に追従するスタッフ向け権限ガード */
const StaffPermissionGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { auth } = useContext<any>(AuthContext)
  const { account, permissions, permissionsLoading, permissionsLoaded, permissionsError } = useContext<any>(AccountContext)
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    const isSelfCheckinPage = location.pathname.search(/^\/self-check(in|out)/) === 0
    if (!auth || isSelfCheckinPage || !usesHotelPmsStaffPermissions(account)) {
      return
    }

    const currentPath = location.pathname
    if (currentPath === '/permission-denied') {
      return
    }
    if (permissionsLoading) {
      return
    }
    if (!permissionsLoaded && !permissionsError) {
      return
    }
    if (permissionsError || !permissionsLoaded || !permissions) {
      history.replace('/permission-denied')
      return
    }
    const screenKey = getScreenKeyByPathname(currentPath)
    if (!isScreenDenied(permissions, screenKey)) {
      return
    }

    const fallbackPath = findFirstAllowedStaffPath(permissions)
    if (!fallbackPath) {
      history.replace('/permission-denied')
      return
    }
    if (fallbackPath !== currentPath) {
      history.replace(fallbackPath)
    }
  }, [auth, account, permissions, permissionsLoading, permissionsLoaded, permissionsError, location.pathname, history])

  return <>{children}</>
}

export const Router: React.FC = () => {
  const { auth } = useContext<any>(AuthContext)
  const { account } = useContext<any>(AccountContext)

  const selfCheckinRouteMap = () => {
    const routes: Array<{ path: string; component: React.FC<any> }> = [
      { path: '/self-checkin', component: FrontTabletHome },
      { path: '/self-checkin/search-reservation', component: SearchReservation },
      { path: '/self-checkin/select-reservation', component: SelectReservation },
      { path: '/self-checkin/qr-checkin-camera', component: SmartCheckinQrReader },
      { path: '/self-checkin/accommodation-info', component: AccommodationInfo },
      { path: '/self-checkin/additional-guest-info', component: AdditionalGuestInfo },
      { path: '/self-checkin/checkin-customize', component: CheckinCustomize },
      { path: '/self-checkin/identity-verify/upload-license', component: SelfCheckinUploadLicense },
      { path: '/self-checkin/identity-verify/upload-passport', component: SelfCheckinUploadPassport },
      { path: '/self-checkin/confirm', component: SelfCheckinConfirm },
      { path: '/self-checkin/info/edit', component: SelfCheckinInfoEdit },
      { path: '/self-checkin/additional-guest-info/edit', component: AdditionalGuestInfoEdit },
      { path: '/self-checkin/payment', component: CheckinPayment },
      { path: '/self-checkin/payment/terminal/card', component: SelfCheckinPaymentTerminalWithCard },
      { path: '/self-checkin/payment/terminal/qr', component: SelfCheckinPaymentTerminalWithQr },
      { path: '/self-checkin/issue-room-key', component: SelfCheckinIssueRoomKey },
      { path: '/self-checkin/complete', component: SelfCheckinComplete },

      { path: '/self-checkout/read-room-key', component: Checkout.ReadRoomKey },
      { path: '/self-checkout/search-reservation', component: Checkout.SearchReservation },
      { path: '/self-checkout/select-reservation', component: Checkout.SelectReservation },
      { path: '/self-checkout/qr-camera', component: Checkout.QrCamera },
      { path: '/self-checkout/payment', component: Checkout.Payment },
      { path: '/self-checkout/payment/terminal/card', component: Checkout.PaymentTerminalWithCard },
      { path: '/self-checkout/payment/terminal/qr', component: Checkout.PaymentTerminalWithQr },
      { path: '/self-checkout/complete', component: Checkout.Complete },
    ]
    return routes.map(r => <Route exact key={r.path} {...r} />)
  }
  const isSelfCheckinPage = window.location.pathname.search(/^\/self-check(in|out)/) === 0

  if (!auth || isSelfCheckinPage) {
    return (
      <BrowserRouter>
        <Switch>
          {selfCheckinRouteMap()}
          <Route exact path="/" component={Signin} />
          <Route exact path="/qr-checkin" component={Signin} />
          <Route exact path="/auth/mfa-announce" component={MfaAnnounce} />
          <Route exact path="/auth/otp" component={VerifyOtp} />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    )
  }

  return (
    <BrowserRouter>
      <StaffPermissionGuard>
        {hasCleanerRole(account) && (
          <Switch>
            <Route exact path="/cleaning" component={CleaningManagerForCleaner} />
            <Route exact path="/cleaning/schedule" component={CleaningManagerScheduleForCleaner} />
            <Route exact path="/cleaning/detail/:roomId" component={CleaningManagerDetail} />
            <Redirect to="/cleaning" />
          </Switch>
        )}
        {hasRestaurantOnlyRole(account) && (
          <Switch>
            <Route exact path="/restaurant-manager" component={RestaurantManager} />
            <Redirect to="/restaurant-manager" />
          </Switch>
        )}
        {hasStaffRole(account) && (
          <Media query="(max-width: 599px)">
            {matches =>
              matches ? (
                <Switch>
                  <Route exact path="/mobile-menu" component={MobileMenu} />
                  <Route exact path="/qr-checkin" component={QrScan} />
                  <Route exact path="/qr-checkin/scan" component={QrScan} />
                  <Route exact path="/qr-checkin/camera" component={QrCamera} />
                  <Route exact path="/qr-checkin/complete" component={QrComplete} />
                  <Route exact path="/permission-denied" component={PermissionDenied} />
                  {selfCheckinRouteMap()}
                  <Route exact path="/tablet-register" component={TabletRegisterPage} />
                  <Redirect to="/mobile-menu" />
                </Switch>
              ) : (
                <Switch>
                  <Route exact path="/dashboard" component={Dashboard} />
                  <Route exact path="/reservation/suggest" component={ReservationSuggest} />
                  <Route
                    exact
                    path="/reservation/:id"
                    render={props => <ReservationDetailRoute component={ReservationDetail} {...props} />}
                  />
                  <Route exact path="/accommodation-management" component={AccommodationManagement} />
                  <Route exact path="/accommodation-management/custom-export" component={CustomExport} />
                  <Route exact path="/checkin/:id" render={props => <ReservationDetailRoute component={CheckinDetail} {...props} />} />
                  <Route exact path="/stay/:id" render={props => <ReservationDetailRoute component={StayDetail} {...props} />} />
                  <Route exact path="/checkout/:id" render={props => <ReservationDetailRoute component={CheckoutDetail} {...props} />} />
                  <Route exact path="/entire-search" component={EntireSearch} />
                  <Route exact path="/csv-upload-history/list" component={UploadHistory} />
                  <Route exact path="/csv-download-history/list" component={DownloadHistory} />
                  <Route exact path="/sales-manager/receipt-history/list" component={ReceiptHistory} />
                  <Route exact path="/customer/list" component={CustomerList} />
                  <Route exact path="/customer/list/csv-download-history" component={CustomerDownloadHistory} />
                  <Route exact path="/customer/:id" component={CustomerDetail} />
                  <Route exact path="/room-manager/daily" component={RoomManagerDaily} />
                  <Route exact path="/room-manager/indicator" component={RoomManagerIndicator} />
                  <Route exact path="/sales-manager" component={SalesManagerDashboard} />
                  <Route exact path="/sales-manager/detail-day" component={SalesManagerDetailByDaily} />
                  <Route exact path="/sales-manager/detail-month" component={SalesManagerDetailByMonthly} />
                  <Route exact path="/sales-manager/detail-list" component={SalesManagerDetailList} />
                  <Route exact path="/request-manager" component={RequestManager} />
                  <Route exact path="/restaurant-manager" component={RestaurantManager} />
                  <Route exact path="/space-manager" component={SpaceManager} />
                  <Route exact path="/sales-manager/business-forms" component={SalesManagerBusinessForms} />
                  <Route exact path="/sales-manager/advance-money" component={AdvanceMoney} />
                  <Route exact path="/sales-manager/sales-accounting" component={SalesManagerAccounting} />
                  <Route exact path="/operation-log" component={OperationLog} />
                  <Route exact path="/operation-log/legacy" component={OperationLogLegacyPage} />
                  <Route exact path="/mail-delivery-history" component={MailDeliveryHistoryList} />
                  <Route exact path="/setting/account" component={SettingAccount} />
                  <Route exact path="/setting/account/edit" component={SettingAccountEdit} />
                  <Route exact path="/setting/account/receipt-edit" component={SettingAccountReceiptEdit} />
                  <Route exact path="/setting/account/company-info-edit" component={SettingAccountCompanyInfoEdit} />
                  <Route exact path="/setting/guest-room-number" component={SettingGuestRoomNumber} />
                  <Route exact path="/setting/guest-room-type" component={SettingGuestRoomType} />
                  <Route exact path="/setting/guest-room-floor" component={SettingGuestRoomFloor} />
                  <Route exact path="/setting/guest-room-auto-assign" component={SettingGuestRoomAutoAssign} />
                  <Route exact path="/setting/guest-room-key" component={SettingGuestRoomKey} />
                  <Route exact path="/setting/room-rate-rank" component={SettingRoomRateRank} />
                  <Route exact path="/setting/room-rate-base" component={SettingRoomRateBase} />
                  <Route exact path="/setting/room-rate-calendar" component={SettingRoomRateCalendar} />
                  <Route exact path="/setting/sales-manager/department" component={SettingSalesManagerDepartment} />
                  <Route exact path="/setting/sales-manager/sales" component={SettingSalesManagerSales} />
                  <Route exact path="/setting/sales-manager/sub-subject" component={SettingSalesManagerSubSubject} />
                  <Route exact path="/setting/sales-manager/payment" component={SettingSalesManagerPayment} />
                  <Route exact path="/setting/sales-manager/register" component={SettingSalesManagerRegister} />
                  <Route exact path="/setting/sales-manager/discount" component={SettingSalesManagerDiscount} />
                  <Route exact path="/setting/sales-manager/subject-set" component={SettingSalesManagerSubjectSet} />
                  <Route exact path="/setting/sales-manager/payment/edit" component={SettingSalesManagerPaymentEdit} />
                  <Route exact path="/setting/sales-manager/register/edit" component={SettingSalesManagerRegisterEdit} />
                  <Route exact path="/setting/sales-manager/discount/edit" component={SettingSalesManagerDiscountEdit} />
                  <Route exact path="/setting/sales-manager/accounts-receivable" component={SettingSalesManagerAccountsReceivable} />
                  <Route
                    exact
                    path="/setting/sales-manager/accounts-receivable/edit"
                    component={SettingSalesManagerAccountsReceivableEdit}
                  />
                  <Route exact path="/setting/sales-manager/accounts-receivable-display" component={AccountsReceivableDisplay} />
                  <Route exact path="/setting/sales-manager/tax" component={SettingSalesManagerTax} />
                  <Route exact path="/setting/custom-checkin" component={SettingCustomCheckin} />
                  <Route exact path="/setting/custom-checkin/edit" component={SettingCustomCheckinEdit} />
                  <Route exact path="/setting/self-checkin" component={SettingSelfCheckin} />
                  <Route exact path="/setting/printer/self-checkin" component={SettingPrinterSelfCheckin} />
                  <Route exact path="/setting/printer/request" component={SettingPrinterRequest} />
                  <Route exact path="/setting/reservation/channel-code" component={SettingReservationChannelCode} />
                  <Route exact path="/setting/reservation/channel-code/edit" component={SettingReservationChannelCodeEdit} />
                  <Route exact path="/setting/reservation/market-segment" component={SettingReservationMarketSegment} />
                  <Route exact path="/setting/reservation/plan" component={SettingReservationPlan} />
                  <Route exact path="/setting/reservation/task-management" component={SettingReservationTaskManagement} />
                  <Route exact path="/setting/reservation/market-segment/edit" component={SettingReservationMarketSegmentEdit} />
                  <Route exact path="/setting/payment" component={SettingPayment} />
                  <Route exact path="/setting/staff" component={SettingStaff} />
                  <Route exact path="/setting/notification" component={SettingNotification} />
                  <Route exact path="/setting/cleaning-manager" component={SettingCleaningManager} />
                  <Route exact path="/setting/cleaning-manager/check-list" component={CheckList} />
                  <Route exact path="/setting/customer-manager" component={CustomerManager} />
                  <Route exact path="/setting/restaurant/highlight" component={SettingRestaurantHighlight} />
                  <Route exact path="/setting/restaurant/display-subject" component={SettingRestaurantDisplaySubject} />
                  <Route exact path="/setting/mail-delivery" component={SettingMailDelivery} />
                  <Route exact path="/setting/mail-delivery-content/mail/new" component={MailDeliveryContentNew} />
                  <Route exact path="/setting/mail-delivery-content/mail/:id" component={MailDeliveryContentEdit} />
                  <Route exact path="/setting/mail-delivery-content/sms/new" component={SMSDeliveryContentNew} />
                  <Route exact path="/setting/mail-delivery-content/sms/:id" component={SMSDeliveryContentEdit} />
                  <Route exact path="/setting/reply-to" component={SettingReplyTo} />
                  <Route exact path="/setting/guest-app/asset" component={SettingGuestAppAsset} />
                  <Route exact path="/setting/guest-app/asset/:id" component={SettingGuestAppAssetDetail} />
                  <Route exact path="/setting/guest-app/asset/:id/map-category" component={SettingGuestAppAssetDetail} />
                  <Route exact path="/setting/guest-app/asset/:id/request-category" component={SettingGuestAppAssetDetail} />
                  <Route exact path="/setting/guest-app/asset/:id/request-tag" component={SettingGuestAppAssetDetail} />
                  <Route exact path="/setting/guest-app/asset/:id/request-sales-hour" component={SettingGuestAppAssetDetail} />
                  <Route exact path="/setting/guest-app/asset/:id/request-notification" component={SettingGuestAppAssetDetail} />
                  <Route exact path="/setting/guest-app/design" component={SettingGuestAppDesign} />
                  <Route exact path="/setting/checkin/self-checkin" component={NewCheckinSetting.SelfCheckin} />
                  <Route exact path="/setting/checkin/self-checkout" component={NewCheckinSetting.SelfCheckout} />
                  <Route exact path="/setting/checkin/card-reader" component={NewCheckinSetting.SelfCheckinCardReader} />
                  <Route exact path="/setting/checkin/terminal" component={NewCheckinSetting.SelfCheckinTerminal} />
                  <Route exact path="/setting/checkin/cash-changer" component={NewCheckinSetting.SelfCheckinCashChanger} />
                  <Route exact path="/setting/checkin/custom-checkin" component={NewCheckinSetting.CustomCheckin} />
                  <Route exact path="/setting/checkin/time-selection" component={NewCheckinSetting.TimeSelection} />
                  <Route exact path="/setting/checkin/time-selection/new" component={NewCheckinSetting.TimeSelectionDetailPage} />
                  <Route exact path="/setting/checkin/time-selection/:id" component={NewCheckinSetting.TimeSelectionDetailPage} />
                  <Route exact path="/setting/checkin/custom-checkin/new" component={NewCheckinSetting.CustomCheckinEdit} />
                  <Route exact path="/setting/checkin/custom-checkin/:id" component={NewCheckinSetting.CustomCheckinEdit} />
                  <Route exact path="/setting/survey" component={SettingSurvey} />
                  <Route exact path="/setting/survey/google-map" component={SurveyGoogleMap} />
                  <Route exact path="/setting/survey/new" component={SurveyEdit} />
                  <Route exact path="/setting/survey/:id" component={SurveyEdit} />
                  <Route exact path="/setting/smart-key/room" component={SettingGuestRoomKey} />
                  <Route exact path="/setting/smart-key/space" component={SmartKeySpace} />
                  <Route exact path="/qr-checkin" component={QrScan} />
                  <Route exact path="/qr-checkin/scan" component={QrScan} />
                  <Route exact path="/qr-checkin/camera" component={QrCamera} />
                  <Route exact path="/qr-checkin/complete" component={QrComplete} />
                  {selfCheckinRouteMap()}
                  <Route exact path="/cleaning-manager/status" component={CleaningManager} />
                  <Route exact path="/cleaning-manager/schedule" component={CleaningManagerSchedule} />
                  <Route exact path="/coupons-manager" component={CouponsManager} />
                  <Route exact path="/reports-manager" component={ReportsManager} />
                  <Route exact path="/tablet-register" component={TabletRegisterPage} />
                  <Route exact path="/accounts-receivable-manager" component={AccountsReceivableManagerList} />
                  <Route exact path="/accounts-receivable-manager/balance" component={AccountsReceivableManagerBalance} />
                  <Route exact path="/accounts-receivable-manager/receipt" component={AccountsReceivableManagerReceiptHistory} />
                  <Route exact path="/invoice-manager" component={InvoiceManagerList} />
                  <Route exact path="/survey/summary" component={SurveySummary} />
                  <Route exact path="/survey/answers" component={SurveyAnswers} />
                  <Route exact path="/permission-denied" component={PermissionDenied} />
                  <Redirect to="/dashboard" />
                </Switch>
              )
            }
          </Media>
        )}
      </StaffPermissionGuard>
    </BrowserRouter>
  )
}
